import { IAM } from '../apis.js';
const changelogsAPI = IAM('/changelogs');
export const getUnseen = async () => changelogsAPI('GET', '/?dismissed=false');
export const getAll = async () => changelogsAPI('GET', '/');
export const dismiss = async (changelogs) => changelogsAPI('POST', '/dismiss', {
    body: changelogs,
});
export const create = async (changelog) => changelogsAPI('POST', '/', {
    body: changelog,
});
//# sourceMappingURL=changelogs.js.map